import { createAction, props } from '@ngrx/store';
import { MgError } from '../../models/error.model';
import { FeeQuoteRequest, FxRequest } from './types';

export enum FeeQuoteActions {
  GET_FEE_QUOTE = '[FeeQuote] Get FeeQuote',
  GET_FEE_QUOTE_SUCCESS = '[FeeQuote] Get FeeQuote Success',
  GET_FEE_QUOTE_FAILED = '[FeeQuote] Get FeeQuote Failed',
  CLEAR_FEE_QUOTE_DATA = '[FeeQuote] Clear FeeQuote Details',
  GET_FX_RATE = '[FeeQuote] Get FxRate',
  GET_FX_RATE_SUCCESS = '[FeeQuote] Get FxRate Success',
  GET_FX_RATE_FAILED = '[FeeQuote] Get FxRate Failed',
  SET_USER_TRN_AMOUNT = '[FeeQuote Set User trn amount',
  SET_USER_TRN_CURRENCY = '[FeeQuote Set User trn currency',
}

export const GetFeeQuoteAction = createAction(
  FeeQuoteActions.GET_FEE_QUOTE,
  props<{ feeLookupRequest: FeeQuoteRequest; endpoint: string, operation: string }>()
);

export const GetFeeQuoteSucessAction = createAction( // Todo: #typo - "Sucess"
  FeeQuoteActions.GET_FEE_QUOTE_SUCCESS,
  props<{ feeLookupResponse: any }>() // Todo: Tim: update typed based on expect feeQuoteResponse
);

export const SetUserTrnAmountAction = createAction(
  FeeQuoteActions.SET_USER_TRN_AMOUNT,
  props<{ amount: number | any }>()
);

export const SetUserTrnCurrencyAction = createAction(
  FeeQuoteActions.SET_USER_TRN_CURRENCY,
  props<{ currency: string }>()
);

export const GetFeeQuoteFailedAction = createAction(
  FeeQuoteActions.GET_FEE_QUOTE_FAILED,
  props<{ error: MgError }>()
);

export const ClearFeeQuoteAction = createAction(
  FeeQuoteActions.CLEAR_FEE_QUOTE_DATA
);

export const GetFxRateAction = createAction(
  FeeQuoteActions.GET_FX_RATE,
  props<{ fxRequest: FxRequest; endpoint: string }>()
);

export const GetFxRateSuccessAction = createAction(
  FeeQuoteActions.GET_FX_RATE_SUCCESS,
  props<{ fxRateResponse: any }>()
);

export const GetFxRateFailedAction = createAction(
  FeeQuoteActions.GET_FX_RATE_FAILED,
  props<{ error: any }>()
);
